import { render } from "./SavedIdeas.vue?vue&type=template&id=9c39d7fe"
import script from "./SavedIdeas.vue?vue&type=script&lang=js"
export * from "./SavedIdeas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__